export * from "Search/Scenarios/Shared/Components/SearchInput/index";
